<script>
import RecruitContent from "@/components/career/RecruitContent.vue";

export default {
  name: "Staff02",
  components: {RecruitContent},
  data(){
    return {
      heading01: '',
      heading02: '',
      heading03: ''
    }
  },
  methods: {
    resize(){
      const text = '法律事務所から\n化学メーカーへ。\n社会に役立つ製品を届けたい。'
      const textMB =`法律事務所から化学メーカーへ。\n社会に役立つ製品を届けたい。`
      const heading02 = `事業を軌道に乗せるべく、\n顧客との良好な関係を\n導いていく。`
      const heading02MB = '事業を軌道に乗せるべく、\n顧客との良好な関係を導いていく。'
      const heading03 = '法律以外の知識も吸収し専門性を高め、\n幅広い解決策を提示できる人財へ。'
      const heading03MB = '法律以外の知識も吸収し\n専門性を高め、\n幅広い解決策を提示できる人財へ。'
      if(window.innerWidth < 901){
        this.heading01 = textMB
        this.heading03 = heading03MB
        this.heading02 = heading02MB
      }else{
        this.heading01 = text
        this.heading03 = heading03
        this.heading02 = heading02
      }
    }
  },
  mounted() {
    this.resize()
    window.addEventListener('resize', this.resize)
  }
}
</script>

<template>
<div>
  <recruit-content
      name="儀間 ゆうな"
      office="法務部"
      join-year="2021"
      sort="02"
      tags="#社会への貢献 #企業法務 #他部署との協働"
      title="法　務"
      description01="法律の専門性を磨きながら、"
      description02="事業の基盤を作り上げていく。"
      :banner="require('@/assets/img/career/03/hero.jpg')"
      :banner-sp="require('@/assets/img/career/03/hero-sp.jpg')"
      :answer-heading01="heading01"
      :answer-image01="require('@/assets/img/career/03/image-01.jpg')"
      answer-paragraph01="前職では、法律事務所で弁護士として個人の方の離婚・相続問題といった家事事件や、一般民事事件を主に担当していました。転職活動のきっかけは、「個々の依頼者だけでなく、より多くの人々に影響を与える企業の仕事に携わり世の中に貢献したい」という思いが強まったからです。メーカーの法務部で働く友人から、自分の携わった製品が世の中の人々の生活を支えていることにやりがいを感じるという話を聞いて、メーカーへの憧れが大きくなりました。様々な業界のメーカーの中で、クレハに惹かれたのは「ナケレバ、ツクレバ。」というビジョンに共感したからです。まだ世の中にないものであっても、それが社会に必要なものなら私たちの手で作り出そう。そんな真摯な思いが感じられ、社会へ貢献したいという私の思いに合った会社だと感じました。また、面接を通して社員の皆さんの人柄の良さを感じられたのも、入社への後押しとなりました。自分たちの会社をどうしたいか、何が課題だと考えているかを、素直に伝えてくれる社員の皆さんの姿を見て、こういう人たちと一緒に働きたいと思ったのです。"
      :answer-heading02="heading02"
      :answer-image02="require('@/assets/img/career/03/image-02.jpg')"
      answer-paragraph02="クレハの法務部は事業部ごとに担当が分かれており、私は主に農薬・医薬品・フッ素製品事業を担当しています。具体的な業務としては、契約書のドラフト作成やレビュー、独占禁止法など各種の法律に関する相談対応などがあります。また、社内の法務研修や法令情報に関する全社向けの情報発信などにも携わっています。仕事をする中で最もやりがいを感じるのは、自分がサポートした案件が無事に事業化し、社会に役立つ製品を世に送り出せた時です。例えば、売買契約を締結する場合、一般的に売主よりも買主の立場の方が強いため、売主に不利な条件に契約が進んでしまいがちですが、ここで不利な条件を呑んでしまうと、売主であるメーカーにとって後々大きな損害につながってしまうかもしれない。当社にとって譲歩できるものと、決して譲れないもの、そのシビアな線引きを相手方と粘り強く交渉しながら、納得のいく契約を目指します。相手方の提案する契約条項の文面だけでなく、その奥にある意図まで汲み取りながら、交渉の落とし所を探っていくことが法務部の腕の見せどころです。法律の視点から当社と顧客の良好な関係を築き、ひいては社会に役立つ製品作りの一端を担えていることにやりがいを感じています。"
      answer-paragraph03="法律以外にも知見を広げていきたいと考えています。クレハに入社した当初は、企業法務の経験がほとんどなかったため、何もかもが手探りの状態でした。この数年間で、独占禁止法など、企業法務として必要な基礎知識は習得できましたが、知識不足を痛感することもしばしばあります。また、クレハは化学メーカーなので、法律やビジネスの理解をさらに深めることはもちろん、当社の技術やノウハウの価値を高めるための知的財産分野の知識なども求められます。幅広い観点から検討し、よりベストな解決策を提示できるようにするため、知的財産部門や経理・財務部門など他部署と協働するプロジェクトには積極的に手を挙げるようにしています。クレハは、チームでの協働を大切にしている人が多いため、様々な専門性を持った人とチームで協働しながらゴールを目指そうとする姿勢を強く感じます。自分の経験を還元し、チームメンバーの知識を吸収しながら成長する。この魅力的な環境を生かして、これからも自分の強みを伸ばしていきたいですね。"
      :answer-heading03="heading03"
      :answer-image03="require('@/assets/img/career/03/image-04.jpg')"
      :banner-full="require('@/assets/img/career/03/image-03.jpg')"
      :banner-full-sp="require('@/assets/img/career/03/image-03-sp.jpg')"
  />
</div>
</template>

<style scoped lang="scss">

</style>
